import React, { useEffect, useState } from "react";
import { useAppSelector } from "../../../hooks";
import { useCompleteStep } from "../hooks/useCompleteStep";
import { useNavigate } from "react-router-dom";
import { CheckCircle, Package, ExternalLink } from "lucide-react";

const InventoryStep: React.FC = () => {
  const navigate = useNavigate();
  const products = useAppSelector((s) => s.products.products);
  const { complete, onboarding, stepIndex, dashboardPath } = useCompleteStep("inventory");
  const [hasVisited, setHasVisited] = useState(false);

  useEffect(() => {
    if (products.length > 0 && !onboarding.completedSteps[stepIndex]) {
      complete();
    }
  }, [products, onboarding.completedSteps, stepIndex, complete]);

  if (onboarding.completedSteps[stepIndex]) {
    return (
      <div className="flex flex-col items-center justify-center py-12 text-center">
        <CheckCircle className="h-16 w-16 text-green-500 mb-4" />
        <h3 className="text-xl font-semibold text-gray-800">Inventory Added!</h3>
        <p className="text-gray-500 mt-2">You have {products.length} product(s) in your inventory.</p>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto text-center">
      <div className="rounded-xl border bg-white p-8 shadow-sm">
        <Package className="h-12 w-12 text-primary mx-auto mb-4" />
        <h3 className="text-lg font-semibold mb-2">Add Your Products</h3>
        <p className="text-gray-500 text-sm mb-6">
          Add products to your inventory so your cashiers can start making sales.
        </p>

        <button
          onClick={() => {
            setHasVisited(true);
            navigate(`${dashboardPath}/items`);
          }}
          className="form-btn w-full flex items-center justify-center gap-2"
        >
          <span>Go to Inventory</span>
          <ExternalLink className="h-4 w-4" />
        </button>

        {hasVisited && products.length === 0 && (
          <button
            onClick={() => complete()}
            className="mt-4 w-full rounded border border-gray-300 px-4 py-2 text-sm text-gray-600 hover:bg-gray-50"
          >
            I've added my products
          </button>
        )}
      </div>
    </div>
  );
};

export default InventoryStep;
